import React from 'react';
import PropTypes from 'prop-types';
import DateTimePicker from 'react-datetime-picker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormGroup } from 'reactstrap';

const DATE_FORMAT = 'MM/dd/yyyy';
const TIME_FORMAT = 'h:mm a';
const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

const TableFilterDateTime = ({ filter, onChange }) => (
  <FormGroup className="m-0 custom-filter">
    <DateTimePicker
      value={filter.value}
      onChange={onChange}
      format={DATE_TIME_FORMAT}
      calendarType="US"
      calendarIcon={(<FontAwesomeIcon icon="calendar-alt" />)}
      clockIcon={(<FontAwesomeIcon icon="clock" />)}
      clearIcon={(<FontAwesomeIcon icon="times" />)}
      className="form-control form-control-sm"
    />
  </FormGroup>
);

TableFilterDateTime.propTypes = {
  filter: PropTypes.shape(),
  onChange: PropTypes.func.isRequired,
};

TableFilterDateTime.defaultProps = {
  filter: {},
};

export default TableFilterDateTime;

